import { ActionContext } from 'vuex';
import { getStoreAccessors } from 'vuex-typescript';

type AddressContext = ActionContext<AddressState, any>;

export interface IAddress {
  additionalAddress?: string;
  companyName: string;
  country: string;
  flatNo: string;
  formattedAddress: string;
  postalBox: string;
  postCode: string;
  residence?: string;
  street: string;
  streetNo?: string;
  town: string;
}

export interface AddressState {
  address: IAddress[];
  postCode: string;
}

const state: AddressState = {
  postCode: '',
  address: [],
};

const getters = {
  postCode(s: AddressState) {
    return s.postCode;
  },

  address(s: AddressState) {
    return s.address;
  },
};

const mutations = {
  postCode(s: AddressState, postCode: string) {
    s.postCode = postCode;
  },

  address(s: AddressState, addresses: IAddress[]) {
    s.address = addresses;
  },
};

const actions = {
  postCode(context: AddressContext, postCode: string) {
    context.commit('postCode', postCode);
  },

  address(context: AddressContext, addresses: IAddress[]) {
    context.commit('address', addresses);
  },
};
export const address = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
const { read, dispatch } = getStoreAccessors<AddressState, any>('app/address');

const setPostCode = dispatch(address.actions.postCode);
const setAddress = dispatch(address.actions.address);

const getPostCode = read(address.getters.postCode);
const getAddress = read(address.getters.address);

export const appAddressHelper = {
  setPostCode,
  setAddress,
  getPostCode,
  getAddress,
};
